module.exports = __webpack_public_path__ + "img/بروشورa4.79081031.jpg";